"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isCreditsProperty = exports.creditsPropertyDefinition = void 0;
exports.creditsPropertyDefinition = {
    view: {
        label: 'Credits',
        style: '',
        hint: 'Where did you get this from?',
    },
    constraints: [
        {
            name: 'required',
            argument: true,
        },
        {
            name: 'maxLength',
            argument: 127,
        },
    ],
    type: 'text',
    multiple: false,
    name: 'credits',
};
const isCreditsProperty = (prop) => {
    return prop.name === exports.creditsPropertyDefinition.name;
};
exports.isCreditsProperty = isCreditsProperty;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY3JlZGl0cy5wcm9wZXJ0eS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9wcm9wZXJ0aWVzL2NyZWRpdHMucHJvcGVydHkudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBRWEsUUFBQSx5QkFBeUIsR0FBRztJQUN2QyxJQUFJLEVBQUU7UUFDSixLQUFLLEVBQUUsU0FBUztRQUNoQixLQUFLLEVBQUUsRUFBRTtRQUNULElBQUksRUFBRSw4QkFBOEI7S0FDckM7SUFDRCxXQUFXLEVBQUU7UUFDWDtZQUNFLElBQUksRUFBRSxVQUFVO1lBQ2hCLFFBQVEsRUFBRSxJQUFJO1NBQ2Y7UUFDRDtZQUNFLElBQUksRUFBRSxXQUFXO1lBQ2pCLFFBQVEsRUFBRSxHQUFHO1NBQ2Q7S0FDRjtJQUNELElBQUksRUFBRSxNQUFNO0lBQ1osUUFBUSxFQUFFLEtBQUs7SUFDZixJQUFJLEVBQUUsU0FBUztDQUNnQixDQUFBO0FBSTFCLE1BQU0saUJBQWlCLEdBQUcsQ0FBQyxJQUFrQixFQUEyQixFQUFFO0lBQy9FLE9BQU8sSUFBSSxDQUFDLElBQUksS0FBSyxpQ0FBeUIsQ0FBQyxJQUFJLENBQUE7QUFDckQsQ0FBQyxDQUFBO0FBRlksUUFBQSxpQkFBaUIscUJBRTdCIn0=